import { translator } from "../../../translation/translator";
import { SearchProductUpdatedByModalSetup } from "../../../search/user/modal/search-product-updated-by-modal-setup";
import { ChipPickerHandler } from "../chips/chip-picker-handler";
import { ChipPickerListener } from "../chips/chip-picker-listener";
import { SearchProductUpdatedByPickerForm } from "./search-product-updated-by-picker-form";

export interface SearchProductUpdatedByPickerSetupParams {
    menuRoot: HTMLElement;
    initialSelectedIds: string[];
    onSelectionChange: (ids: string[]) => void;
}

export class SearchProductUpdatedByPickerSetup {
    public static setupForSearchMenu(params: SearchProductUpdatedByPickerSetupParams): ChipPickerHandler | null {
        const { menuRoot, initialSelectedIds, onSelectionChange } = params;

        const pickerRoot = SearchProductUpdatedByPickerForm.getPickerRoot(menuRoot);
        const chipsEl = SearchProductUpdatedByPickerForm.getChips(menuRoot);

        if (!(pickerRoot instanceof HTMLElement) || !(chipsEl instanceof HTMLElement)) {
            return null;
        }

        const modal = SearchProductUpdatedByModalSetup.init(document);
        if (!modal) return null;

        const instanceKey = (() => {
            const existing = String(pickerRoot.dataset.pickerInstanceKey || "").trim();
            if (existing) return existing;
            const created = `search-product-updated-by-picker-${Date.now()}-${Math.random().toString(16).slice(2)}`;
            pickerRoot.dataset.pickerInstanceKey = created;
            return created;
        })();

        const controller = new ChipPickerHandler({
            chipsEl,
            openBtnEl: pickerRoot,
            idAttribute: "data-user-id",
            removeAction: "remove",
            renderOptions: {
                chipClass: "picker-chip",
                labelClass: "picker-chip__label",
                labelIsHtml: true,
                removeClass: "picker-chip__remove",
                removeAriaLabel: "Remove",
                hideUnknownLabels: true,
                emptyHtml:
                    '<span class="input-placeholder search-item" data-translate="select_user">Select user</span>',
            },
        });

        modal.setSelectedIds(initialSelectedIds);

        controller.setLabelMap(modal.getLabelMap());
        controller.setSelectedIds(initialSelectedIds);
        controller.setOnSelectionChange(onSelectionChange);
        controller.setExternalSelectionUI({
            setSelectedIds: (ids: string[]) => modal.setSelectedIds(ids),
            setOnSelectionChange: (callback: (ids: string[]) => void) =>
                modal.setOnSelectionChange(
                    (ids) => {
                        controller.mergeLabelMap?.(modal.getLabelMap());
                        callback(ids);
                    },
                    { key: instanceKey },
                ),
            open: () => modal.open(),
        });

        controller.render();
        translator.updateUITranslations();

        ChipPickerListener.setup({
            rootEl: pickerRoot,
            scopeKey: "search-product-updated-by-picker",
            openBtnEl: pickerRoot,
            chipsEl,
            controller,
        });

        return controller;
    }
}
